import { useEffect, useMemo, useState } from 'react';

export const useLocalStorage = (key, defaultValue) => {
  const [updater, setUpdater] = useState(false);

  const [value, setValue] = useState(() => {
    let currentValue;

    try {
      currentValue = JSON.parse(localStorage.getItem(key) || String(defaultValue));
    } catch (error) {
      currentValue = defaultValue;
    }

    return currentValue;
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
    setUpdater((prev) => !prev);
  }, [value, key]);

  const currentValue = useMemo(() => value, [updater]);

  return [currentValue, setValue];
};

export default useLocalStorage;
